import { render, staticRenderFns } from "./Multiworld.vue?vue&type=template&id=29f29050&scoped=true&"
import script from "./Multiworld.vue?vue&type=script&lang=js&"
export * from "./Multiworld.vue?vue&type=script&lang=js&"
import style0 from "./Multiworld.vue?vue&type=style&index=0&id=29f29050&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f29050",
  null
  
)

export default component.exports